module.exports = __webpack_public_path__ + "static/media/xd.419b4fdc.svg";